import { Input } from "./input"

export const Select = {
  variants: {
    outline: {
      field: Input.variants.outline.field,
    },
  },
}
